<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <div class="mb-4">
          <account-info :user="store.state.user.user" />
        </div>
        <div class="mb-4">
          <div
            class="text-link cursor-pointer"
            @click="onLogout"
          >
            <div class="card-outlined p-4">
              <h1>ログアウト</h1>
            </div>
          </div>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { axios } from '@/plugins/axios'
import { useStore } from '@/store/index'
import { useRouter } from 'vue-router'
import { ALERT_COLORS } from '@/store/base'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import AccountInfo from '@/components/AccountInfo.vue'

export default defineComponent({
  components: { LayoutsAuth, LayoutsAuthWidth, AccountInfo },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const router = useRouter()

    const onLogout = () => {
      axios
        .get('/logout')
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('logout.success')], persistent: true, color: ALERT_COLORS.info })
          router.push('/login')
        })
    }

    return {
      store,
      onLogout
    }
  },
})
</script>
